import styled from "styled-components";
import { space, typography } from "styled-system";

// Create a <Title> react component that renders an <h1> which is
// centered, palevioletred and sized at 1.5em
export const Title = styled.h1`
  margin: 0;
  font-size: 1em;
  display: flex;
  color: ${(props) => props.theme.colors.default};
`;

export const Logo = styled.h2`
  font-size: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${space}
`;

// Create a <Wrapper> react component that renders a <section> with
// some padding and a papayawhip background
export const Wrapper = styled.section`
  min-height: 80px;
  padding: 0 16px;
  background: white;

  @media (max-width: 480px) {
    min-height: 80px;
    padding: 0 16px;
  }
`;

export const NewTitle = styled(Title)`
  font-size: 2em;
  color: ${(props) => props.theme.colors.blue};
  ${space}
  ${typography}
`;

export const LoginButton = styled.button`
  background-color: #EF4F5F;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size:13px;
  font-weight: 700;
  ${space}
`

export const DesktopWrapper = styled.div`
  position: relative;
  z-index: 1;
  height: 88px;
  background: white;
  box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.04);
  display: flex;
  align-items: center;
  padding: 0 20px;
  gap: 20px;
`;

export const LogoBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

export const VerticalDivider = styled.div`
  width: 1px;
  height: 48px;
  background: #e6e9ef;
  flex-shrink: 0;
`;

export const OutletInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 300px;
  height: 44px;
`;

export const OutletName = styled.p`
  font-size: 18px;
  font-weight: 700;
  color: #293142;
  letter-spacing: -0.18px;
  margin: 0;
`;

export const OutletAddressRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 300px;

  span {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    color: #828282;
  }
`;

export const ChangeOutletLink = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #ef4f5f;
  cursor: pointer;
  white-space: nowrap;
`;

export const ProfileButton = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 100px;
  background: white;
  border: 1px solid #e6e9ef;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  margin-left: auto;
`;
